import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { AddDeviceFormType } from "@/apps/partner/types";
import { Button } from "@/components/Interface/Button/Button";

const MIN_QUANTITY = 1;
const MAX_QUANTITY = 10;

export const PlanQuantitySelector = () => {
  const { t } = useTranslation("partnerPortal", { keyPrefix: "addDevice" });
  const { watch, setValue } = useFormContext<AddDeviceFormType>();
  const quantity = watch("quantity") ?? MIN_QUANTITY;

  const decrement = () => {
    setValue("quantity", Math.max(MIN_QUANTITY, quantity - 1), {
      shouldDirty: true,
    });
  };

  const increment = () => {
    setValue("quantity", Math.min(MAX_QUANTITY, quantity + 1), {
      shouldDirty: true,
    });
  };

  return (
    <div className="flex items-center gap-4">
      <Button
        type="button"
        variant="secondary"
        onClick={decrement}
        disabled={quantity <= MIN_QUANTITY}
        dataTestid="plan-quantity-decrement"
        aria-label={t("quantity.decrement")}
      >
        −
      </Button>
      <span
        className="min-w-8 text-center text-body-lg font-semibold text-foreground-primary"
        data-testid="plan-quantity-value"
      >
        {quantity}
      </span>
      <Button
        type="button"
        variant="secondary"
        onClick={increment}
        disabled={quantity >= MAX_QUANTITY}
        dataTestid="plan-quantity-increment"
        aria-label={t("quantity.increment")}
      >
        +
      </Button>
    </div>
  );
};
